import { GraftCodePrimitiveType, ParsableTypes } from '@graftcode/protocol'

import type { HostingLibraryContext } from '@/core/interfaces/HostingLibraryContext.interface'

import { isGraftAssemblyReference } from './isGraftAssemblyReference'

/**
 * Primitive wire types that UnifiedGraftModelDeserializer rejects (see protocol deserializer switch).
 * GRAFT_MODEL is handled separately via hosted / parsable complex-type rules.
 */
const NON_DOWNLOADABLE_GRAFT_PRIMITIVES = new Set<GraftCodePrimitiveType>([
  GraftCodePrimitiveType.GRAFT_MODEL,
  GraftCodePrimitiveType.NULL,
  GraftCodePrimitiveType.UNDEFINED,
  GraftCodePrimitiveType.DELEGATE,
])

export function isDownloadableGraftPrimitiveType(type: GraftCodePrimitiveType | undefined): boolean {
  return type !== undefined && !NON_DOWNLOADABLE_GRAFT_PRIMITIVES.has(type)
}

/** Uses the cross-runtime parsable type catalog from protocol. */
export function isParsableComplexType(typeFqn: string | undefined | null): boolean {
  const trimmed = typeFqn?.trim()
  if (!trimmed) {
    return false
  }
  if (ParsableTypes.PARSABLE_TYPE_NAMES.has(trimmed)) {
    return true
  }
  return Array.from(ParsableTypes.PARSABLE_TYPE_NAMES).some((parsableName) => trimmed.endsWith(`.${parsableName}`))
}

export function isHostedTypeReference(typeFqn: string, hostedTypeFqns: ReadonlySet<string> | undefined): boolean {
  const trimmed = typeFqn.trim()
  if (!trimmed || !hostedTypeFqns) {
    return false
  }
  return hostedTypeFqns.has(trimmed)
}

export function isGraftModelReferenceGraftable(
  typeFqn: string,
  hostedTypeFqns?: ReadonlySet<string>,
  assemblyName?: string,
  _hostingLibraryContext?: HostingLibraryContext
): boolean {
  if (isHostedTypeReference(typeFqn, hostedTypeFqns) || isParsableComplexType(typeFqn)) {
    return true
  }

  if (isGraftAssemblyReference(assemblyName)) {
    return true
  }

  return false
}
